// apps/portals/staff/src/nav.ts — buildNav([…manifests], session, grants,
// enabled); ZERO hardcoded menu items (DEV-GUIDE-002 §6.4 / REPO-STRUCTURE.md
// §5.1). The desk is deliberately a small surface: one Circulation section,
// gated on lib:desk. Adding a desk screen = adding an entry to modules/lib's
// manifest.
import { buildNav } from "@erp/auth-kit/nav";
import type { ModuleManifest, NavModule } from "@erp/auth-kit/nav";
import type { ModuleId, Session } from "@erp/core-schemas";
import { finStaffNav } from "@erp/module-fin/manifest";
import { guardStaffNav } from "@erp/module-guard/manifest";
import { libStaffNav } from "@erp/module-lib/manifest";
import { GRANTS } from "./grants";

// A guard holds only guard:*, so buildNav filters lib and fin away entirely
// and they see just the gate desk — the existing filter, not a special case.
const MANIFESTS: readonly ModuleManifest[] = [libStaffNav, finStaffNav, guardStaffNav];

/**
 * The sidebar for one session on one INSTALL. `enabled` is the capabilities
 * manifest's module set (ERP-DEPLOYMENT-MODEL §13): a manifest whose module the
 * install omits is dropped before the grant filter, so a desk deployed without
 * `fin` never offers Payments, whatever the role holds. The shell passes
 * `caps.modules()` — `[]` while the manifest is loading, which yields an empty
 * sidebar exactly as a pending /me does.
 */
export function staffNav(session: Session | null, enabled: readonly ModuleId[]): NavModule[] {
  return buildNav(MANIFESTS, session, GRANTS, enabled);
}
